export enum AdminStatusType {
  Active = 'Active',
  Deactivated = 'Deactivated',
}
